import axios from 'axios';
import React from 'react';
import $ from 'jquery';
import { Redirect, Link } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { connect } from 'react-redux';

import { AdminUrls } from '../network/config';

const cpdHome_Url = AdminUrls.COMMON.HOME;

class Home extends React.Component {
  constructor() {
    super();

    this.dashboardContentHandler = this.dashboardContentHandler.bind(this);
    this.handleWindowScreenResize = this.handleWindowScreenResize.bind(this)
    this.closeMenu = this.closeMenu.bind(this);
    
    this.state = {
      queuecount: '',
      dashboardContent: [],
      mainLoading: false,
      redirectToLogin: false,
      currentScreenWidth: window.innerWidth,
    };
    this.controller = new AbortController();
  }

  closeMenu() {
    let element = document.getElementById("bs-example-navbar-collapse-1");
    if (element.classList.contains("in")) {
      element.classList.toggle("in");
    }
  }

  handleWindowScreenResize() {
    this.setState({
      currentScreenWidth: window.innerWidth,
    });
  }


  dashboardContentHandler() {
    this.setState({
      mainLoading: true,
    });
    axios
      .get(cpdHome_Url, {
        method: 'GET',
        signal: this.controller.signal,
        withCredentials: true,
        credentials: 'include',
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        this.setState({
          dashboardContent: response?.data,
          mainLoading: false,
        });
      })

      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.setState({
            redirectToLogin: true,
          });
          localStorage.removeItem('access_token');
          if (this.props && typeof this.props.signOut === 'function') {
            this.props.signOut();
          }
        }
      });
  }

  componentDidMount() {
    this.dashboardContentHandler();
    let successMessage = localStorage.getItem('successMessage');
    //console.log(this.props.user);
    if (successMessage) {
      localStorage.removeItem('successMessage');
      NotificationManager.success(successMessage, 'Login Successful');
    }
    window.addEventListener('resize', this.handleWindowScreenResize);
  }

  render() {
    const { currentScreenWidth } = this.state
    if (this.state.redirectToLogin) {
      return <Redirect to="/login" />;
    } else {
      return (
        <div>
          <div>
            <section id="portfolio" className="smallfont ng-scope">
              <div>
                <div className="row">
                  {this.state.dashboardContent &&
                    this.state.dashboardContent?.length
                    ? this.state.dashboardContent.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="col-xs-6 col-sm-6 col-md-4 portfolio-item"
                        >
                          <Link to={item?.Action.toLowerCase()} onClick={() => this.closeMenu()}>
                            <div className="panel panel-default">
                              {currentScreenWidth >= 486 && <div className="panel-heading panel-heading-cpd ng-binding">
                                {item?.FeatureName}
                              </div>}
                              <div className="panel-body">
                                <img
                                  id="mycpd"
                                  width="100"
                                  height="100"
                                  alt=""
                                  src={
                                    process.env.PUBLIC_URL +
                                    item?.Face.replace(
                                      'app/images',
                                      '/images'
                                    )
                                  }
                                />
                              </div>
                              <div className="panel-footer cpdfooter ng-binding">
                                {currentScreenWidth <= 486 ? item?.FeatureName : item?.FeatureDesc}
                              </div>
                            </div>
                          </Link>
                        </div>
                      );
                    })
                    : ''}
                </div>
              </div>
            </section>
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};

export default connect(mapStateToProps)(Home);
